module.exports = __webpack_public_path__ + "static/media/card_s3b.61f5cf40.jpg";